import { useEffect } from 'react';

const Policy = () => {
  useEffect(() => {
    window.location.href = '/policy.html';
  }, []);

  return null;
};

export default Policy;